// extracted by mini-css-extract-plugin
export var option = "_3x-1";
export var optionActive = "_3x-2";
export var pill = "_3x-0";